import { MagnifyingGlass } from '@phosphor-icons/react'

/**
 * Campo de búsqueda reutilizable con icono y estilos compartidos de Torre.
 * El componente padre controla el texto y aplica el filtrado o la búsqueda.
 *
 * `value` contiene el texto actual y `onChange` recibe el evento del input.
 * `onKeyDown` permite manejar teclas como Enter; `inputRef` permite enfocar el campo.
 * `disabled` deshabilita el input. `placeholder` muestra la ayuda cuando está vacío
 * y `ariaLabel` define su nombre accesible para lectores de pantalla.
 * `className` agrega clases al contenedor. No ejecuta búsquedas ni aplica debounce.
 *
 * Ejemplo (search y setSearch pertenecen al estado del componente padre):
 * <UbiquaSearchField
 *   value={search}
 *   onChange={(event) => setSearch(event.target.value)}
 *   placeholder="Buscar usuarios..."
 *   ariaLabel="Buscar usuarios"
 *   onKeyDown={(event) => {
 *     if (event.key === 'Enter') searchUsers(search)
 *   }}
 * />
 */
export default function UbiquaSearchField({
  value,
  onChange,
  onKeyDown,
  inputRef,
  disabled = false,
  placeholder = 'Buscar...',
  ariaLabel = 'Buscar',
  className = ''
}) {
  return (
    <label className={`ubiqua-search-field ${className}`}>
      <MagnifyingGlass size={16} aria-hidden="true" />
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
    </label>
  )
}
